import React, { useState } from "react";
import {
  Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter,
} from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Textarea } from "@/components/ui/textarea";
import { Label } from "@/components/ui/label";
import api, { formatApiError } from "@/lib/apiClient";
import { Star } from "lucide-react";
import { toast } from "sonner";

export default function RatingDialog({ open, onOpenChange, request, onRated }) {
  const [rating, setRating] = useState(0);
  const [hover, setHover] = useState(0);
  const [comment, setComment] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async () => {
    if (!rating) {
      toast.error("Selecione de 1 a 5 estrelas.");
      return;
    }
    setBusy(true);
    try {
      await api.post(`/requests/${request.id}/rating`, { rating, comment });
      toast.success("Obrigado pela avaliação!");
      onOpenChange(false);
      onRated?.();
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail) || err.message);
    } finally {
      setBusy(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-sm" data-testid="rating-dialog">
        <DialogHeader>
          <DialogTitle>Avaliar atendimento</DialogTitle>
          <DialogDescription>Como foi o serviço do técnico?</DialogDescription>
        </DialogHeader>
        <div className="flex justify-center gap-1 py-2">
          {[1, 2, 3, 4, 5].map((n) => (
            <button
              key={n}
              type="button"
              onMouseEnter={() => setHover(n)}
              onMouseLeave={() => setHover(0)}
              onClick={() => setRating(n)}
              data-testid={`star-${n}`}
            >
              <Star
                className={`h-9 w-9 transition-colors ${
                  (hover || rating) >= n ? "fill-amber-400 text-amber-400" : "text-slate-300"
                }`}
              />
            </button>
          ))}
        </div>
        <div className="space-y-1.5">
          <Label htmlFor="rating-comment">Comentário (opcional)</Label>
          <Textarea id="rating-comment" rows={3} value={comment}
            onChange={(e) => setComment(e.target.value)}
            placeholder="Conte como foi o atendimento" data-testid="rating-comment-input" />
        </div>
        <DialogFooter>
          <Button className="w-full bg-blue-600 hover:bg-blue-700" onClick={submit}
            disabled={busy} data-testid="submit-rating-button">
            {busy ? "Enviando..." : "Enviar avaliação"}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
